export { default } from '../shared/lib/image-external'
export * from '../shared/lib/image-external'
